// Port de app/assinatura.tsx.
import { Carregando } from "@/app/Carregando";
import { useIsFocused } from "@/navigation";
import { cx } from "@/ui/cx";
import { lazy } from "react";
import s from "./assinatura.module.css";

const AssinaturaScreen = lazy(() => import("@/screens/Assinatura"));

// Nativo: Animated.View com opacity 0→1 em 250 ms quando a rota ganha foco (e 1→0 ao
// perder). WEB: a mesma transição em CSS (a rota só existe montada enquanto focada).
export default function AssinaturaRoute() {
  const focused = useIsFocused();
  return (
    <div className={cx(s.container, focused ? s.visivel : s.oculto)}>
      <Carregando>
        <AssinaturaScreen />
      </Carregando>
    </div>
  );
}
